<template>
  <div class="w-full flex gap-twentyFive justify-center mb-lg">
    <component
      v-for="(step, index) in steps"
      :key="step.title"
      :is="!step.clickable || step.current ? 'span' : 'button'"
      :disabled="step.disabled"
      class="group bg-transparent border-none p-0 outline-none font-body"
      :class="{
        'hidden sm:flex sm:items-center': !step.current,
        'flex items-center': step.current,
        'cursor-pointer': !step.current && !step.disabled,
      }"
      @click="() => !step.disabled && goToStep(step, index)"
      :data-test="`step_${index + 1}`"
    >
      <span class="sm:hidden font-normal py-xs text-14">
        {{
          $t('library.progressSteppers.titledProgressStepper.stepXOfY', {
            x: index + 1,
            y: steps.length,
          })
        }}
      </span>
      <div
        class="hidden sm:flex bg-signableBrandColours-signableBlue rounded-full h-twentyFive w-twentyFive justify-center items-center text-signableBrandColours-white text-14 font-semibold"
        :class="{ 'opacity-50': step.disabled }"
      >
        {{ index + 1 }}
      </div>
      <span
        class="relative ml-sm py-xs border-3 border-primary border-solid border-l-0 border-t-0 border-r-0 border-b-0 text-14 font-normal group-focus-visible:outline-orange after:h-none after:block after:select-none after:pointer-none after:content-[attr(data-title)] after:font-bold after:invisible"
        :class="{
          'border-b-3 font-bold pb-2': step.current,
          'opacity-50': step.disabled,
          'group-hover:border-b-3 group-hover:pb-2':
            !step.current && !step.disabled,
        }"
        :data-test="`step_${index + 1}_title`"
        :data-title="step.title"
      >
        {{ step.title }}
      </span>
      <svg
        v-if="index !== steps.length - 1"
        viewBox="0 0 16 29"
        class="hidden sm:block sm:ml-twentyFive w-base h-lg fill-none"
      >
        <path
          class="stroke-2 stroke-gray"
          d="M1 1L14.5 14.5L1 28"
        />
      </svg>
    </component>
  </div>
</template>

<script>
// @ts-check
import { defineComponent } from 'vue';

/**
 * @typedef {object} Step
 * @property {string} title
 * @property {boolean} current
 * @property {boolean} disabled
 * @property {boolean} clickable
 */

export default defineComponent({
  props: {
    /**
     * Steps contains objects that have 'current', 'disabled' and 'title' keys
     * @type {import('vue').PropOptions<Step[]>}
     */
    steps: {
      type: Array,
      required: true,
    },
  },
  setup(_, { emit }) {
    /**
     * @param {Step} step
     * @param {number} index
     */
    function goToStep(step, index) {
      if (!step.current && !step.disabled) {
        emit('goToStep', index);
      }
    }
    return {
      goToStep,
    };
  },
});
</script>
